import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
// Redux
import { RootState } from '@redux/store';
// styles
import './style.scss';
// common function
import { calendarLoc } from '@libs/globalVariables';
import { useTranslation } from 'react-i18next';
// plugin
import dayjs from 'dayjs';
import cN from 'classnames';

interface IMiniCalendar {
    dates?: string[]; // ex:  ["2021-08-05", "2021-08-06"]
    onClickDate?: (date: string) => void;
    defaultdate?: string; // ex: 2021-08-05
    forceSelect?: boolean; // 是否必選日期
    disabledDates?: string[]; // disabled日期
}

const MiniCalendar: React.FC<IMiniCalendar> = (props) => {
    const moduleName = 'MiniCalendar';
    const { t } = useTranslation();
    const { dates, onClickDate, defaultdate, forceSelect, disabledDates } = props;
    const { Language } = useSelector((state: RootState) => state.Common);
    let lang: string;
    // 香港語系翻譯檔與台灣相同
    Language === 'zh-hk' ? lang = 'zh-tw' : lang = Language;
    const [picked, setPicked] = useState<string>(defaultdate || '');
    const sortedDates = useMemo(() => {
        return [...dates].sort((a, b) => (dayjs(a).isAfter(dayjs(b)) ? 1 : -1));
    }, [dates]);
    useEffect(() => {setPicked(defaultdate)}, [defaultdate]);

    return (
        <div className={cN(moduleName)}>
            <div className={cN(`${moduleName}_content`)}>
                {sortedDates.map((date, i) => {
                    const isDisabled = disabledDates.indexOf(date) !== -1;

                    return (
                        <div
                            className={cN('dateBlock', {
                                active: picked === date,
                                disabled: isDisabled,
                            })}
                            key={date}
                            onClick={() => {
                                if (isDisabled) return;
                                if (picked !== date) {
                                    onClickDate(date);
                                    setPicked(date);
                                } else {
                                    if (!forceSelect) {
                                        onClickDate('');
                                        setPicked('');
                                    }
                                }
                            }}
                        >
                            <div className={cN(`${moduleName}_date`)}>
                                {dayjs(date).format('MM-DD')}
                            </div>
                            <div className={cN(`${moduleName}_weekday`)}>
                                {lang && lang === 'zh-tw'
                                    ? `週${calendarLoc[lang]['weekdays'][dayjs(date).get('day')]}`
                                    : calendarLoc[lang]['weekdays'][dayjs(date).get('day')]
                                }
                            </div>
                        </div>
                    );
                })}
                {sortedDates.length <= 0 && (
                    <div className="noDates">
                        {t('THSR.detailInfo.sorryForNoAvailableDates')}
                    </div>
                )}
            </div>
        </div>
    );
};

export default MiniCalendar;

MiniCalendar.defaultProps = {
    dates: [],
    disabledDates: [],
};
